import { HttpClient } from '@angular/common/http';
import * as jwt_decode from 'jwt-decode';
import { tap } from 'rxjs/operators';
import { Environment, EnvironmentConfigService } from '../environment';
import { PlatformServiceName } from './../environment/environment.model';
import { GUID_TO_UUID_REGEX } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "../../../../model/src/lib/environment.token";
import * as i2 from "@angular/common/http";
import * as i3 from "../environment/environment-config.service";
export const USER_PROFILE_KEY = 'user_profile';
/**
 * Consolidated logging service to log and send data to server for further processing
 */
export class UserService {
    constructor(environment, httpClient, environmentConfigService) {
        this.environment = environment;
        this.httpClient = httpClient;
        this.environmentConfigService = environmentConfigService;
        this._serviceUrl = null;
        this._serviceUrl =
            this.environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
                '/' +
                this.environment.serviceUrlList[PlatformServiceName.UserService];
    }
    setUserProfile(username) {
        return this.httpClient
            .get(`${this._serviceUrl}/users/${username}`)
            .pipe(tap((userProfile) => localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(userProfile))));
    }
    getUserProfile() {
        return (localStorage.getItem(USER_PROFILE_KEY) &&
            JSON.parse(localStorage.getItem(USER_PROFILE_KEY)));
    }
    getBusinessAccount() {
        if (this.getAccessTokenFromLocalStorage()) {
            const overrideBaid = localStorage.getItem('selectedBaid');
            if (overrideBaid) {
                return overrideBaid;
            }
            const guid = jwt_decode(this.getAccessTokenFromLocalStorage())['co'];
            this._businessAccount = guid.toLowerCase().replace(GUID_TO_UUID_REGEX, "$1-$2-$3-$4-$5");
            return this.getUserProfile()
                ? this.getUserProfile().user.businessAccountId.value
                : this._businessAccount;
        }
    }
    getAccessTokenFromLocalStorage() {
        return localStorage.getItem('access_token');
    }
    /**
     * Set business account from the access token
     * @param accesToken the access token to retrieve business account
     * @param fieldName the name of the field to retrieve the token
     */
    setBusinessAccountFromAccessToken(accesToken, fieldName) {
        const guid = jwt_decode(accesToken)[fieldName];
        this._businessAccount = guid.toLowerCase().replace(GUID_TO_UUID_REGEX, "$1-$2-$3-$4-$5");
    }
    hasAdministratorPrivileges(accessToken) {
        const token = jwt_decode(accessToken);
        // @TODO: when full role based auth is added, this should be revised.
        // return ['subject', 'email', 'sub'].some(key =>
        return ['uid', 'sub', 'usrprofile'].some(key => this.isAdminAccountDomain(token[key]));
    }
    isAdminAccountDomain(emailAddress) {
        if (emailAddress) {
            const atIndex = emailAddress.lastIndexOf('@');
            // return atIndex >= 0
            //   ? emailAddress.substring(atIndex) === '@omnitracs.com'
            //   : false;
            //The above lines are commented because Unity doesn't have email address. so, I'm using usrprofile instead.
            if (atIndex < 0 && emailAddress === 'I') {
                return true;
            }
        }
        return false; // if no email address.
    }
    getDecodedToken(accessToken) {
        return jwt_decode(accessToken);
    }
}
UserService.ngInjectableDef = i0.defineInjectable({ factory: function UserService_Factory() { return new UserService(i0.inject(i1.ENVIRONMENT), i0.inject(i2.HttpClient), i0.inject(i3.EnvironmentConfigService)); }, token: UserService, providedIn: "root" });
